import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Room, UpdateRoomDto } from '@/core/models/room.model'
import { useEndConsultationMutation } from '@/core/services/consultation'
import { updateRoom } from '@/redux/reducers/room.reducer'
import { useAppDispatch } from '@/redux/rootReducer'

export function useEndEmergencyConsultation(emergencyRoom: Room, { leaveOnCompleted }: { leaveOnCompleted?: boolean } = {}) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [commitMutation] = useEndConsultationMutation()

  const endConsultation = useCallback(async () => {
    if (!emergencyRoom.currentConsultation) return

    try {
      await commitMutation(emergencyRoom.currentConsultation)
      const updateRoomPayload: UpdateRoomDto = { currentConsultation: null }
      if (leaveOnCompleted) updateRoomPayload['status'] = 'available'
      dispatch(updateRoom(emergencyRoom._id, updateRoomPayload))
      if (leaveOnCompleted) navigate('/')
    } catch {
      enqueueSnackbar(t('notification.consultation.update.error'), { variant: 'error' })
    }
  }, [commitMutation, dispatch, emergencyRoom, leaveOnCompleted, navigate])

  return { endConsultation }
}
